import { buildHref } from "@softmax/web-addresses";
import { publicLinks } from "@softmax/web-addresses/discovery";

export type SiteLink = {
  readonly label: string;
  readonly href: string;
  readonly external?: boolean;
  /**
   * A small muted word set after the label, saying who a door is for
   * ("Softmax only"). Drawn by both the nav menu and the footer column.
   */
  readonly note?: string;
};

export const leaguesUrl = buildHref({ name: "browse" });
const discordUrl = publicLinks.discord;

/**
 * A DOOR THAT LEAVES SOFTMAX.COM, wherever it is drawn. The lists above say so
 * by hand; a coworld's docs door cannot, because whether its rules live in our
 * wiki or in its own README is the manifest's answer, not ours. Both the
 * masthead and the signed-in rail ask this before they mark a row, so one
 * coworld's "Rules" is treated the same in both.
 */
export function leavesTheSite(href: string): boolean {
  return /^https?:/i.test(href);
}

export const productLinks: SiteLink[] = [
  { label: "Docs", href: buildHref({ name: "docs" }) },
  {
    label: "Create a coworld",
    href: buildHref({
      name: "docs",
      slug: "coworld/build-a-coworld/overview".split("/"),
    }),
  },
  {
    label: "The SDK",
    href: buildHref({ name: "docs", slug: "coworld/overview".split("/") }),
  },
  {
    label: "Tutorial",
    href: buildHref({ name: "docs", slug: "guides/quickstart".split("/") }),
  },
  {
    label: "Reference",
    href: buildHref({
      name: "docs",
      slug: "api-reference/overview".split("/"),
    }),
  },
];

export const aboutLinks: SiteLink[] = [
  { label: "Team", href: buildHref({ name: "team" }) },
  { label: "Jobs", href: buildHref({ name: "jobs" }) },
  { label: "Mission", href: buildHref({ name: "mission" }) },
  { label: "Writing", href: buildHref({ name: "blog" }) },
  { label: "Media", href: buildHref({ name: "media" }) },
  { label: "Events", href: buildHref({ name: "events" }) },
  { label: "Community", href: discordUrl, external: true },
  { label: "Contact", href: buildHref({ name: "contact" }) },
];

export const navAboutLinks: SiteLink[] = [
  { label: "Mission", href: buildHref({ name: "mission" }) },
  { label: "Team", href: buildHref({ name: "team" }) },
  { label: "Jobs", href: buildHref({ name: "jobs" }) },
  { label: "Contact", href: buildHref({ name: "contact" }) },
];

/** The onboarding flow: the one door for new people and for starting something new. */
export const getStartedLink: SiteLink = {
  label: "Get Started",
  href: buildHref({ name: "getStarted" }),
};

/** Footer-only. */
export const legalLinks: SiteLink[] = [
  { label: "Terms", href: buildHref({ name: "terms" }) },
  { label: "Privacy policy", href: buildHref({ name: "privacy" }) },
];

export const signedInHome = buildHref({ name: "browse" });

const allCoworlds: SiteLink = { label: "Browse", href: leaguesUrl };

export function buildBrowseLinks(
  games: { readonly title: string; readonly href: string }[],
): SiteLink[] {
  return [
    // The way out to every coworld, not a coworld: /browse in either shell.
    allCoworlds,
    ...games.map((game) => ({
      label: game.title,
      href: game.href,
    })),
  ];
}

// Only live catalog data can establish whether a game is still listed.
export const defaultBrowseLinks: SiteLink[] = [allCoworlds];
